import { useCallback } from 'react';
import * as Cesium from 'cesium';
import { ACCENT, ACCENT_FILL } from '../constants';

const scratchPoint = new Cesium.Cartesian3();
const scratchNormal = new Cesium.Cartesian3();
const scratchDiff = new Cesium.Cartesian3();
const scratchToCamera = new Cesium.Cartesian3();

export function useAOIAndFOV(
  viewerRef: React.MutableRefObject<Cesium.Viewer | null>,
  sharedDataSourceRef: React.MutableRefObject<any>,
) {
  const addAOI = useCallback(() => {
    const ds = sharedDataSourceRef.current;
    if (!ds) return;
    ds.entities.add({
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(
          Cesium.Cartesian3.fromDegreesArray([66, 27, 78, 27, 78, 14, 66, 14])
        ),
        material: ACCENT_FILL,
        outline: false,
        classificationType: Cesium.ClassificationType.TERRAIN,
      },
    });
  }, []);

  const isSurfacePointCameraFacing = useCallback((lon: number, lat: number, altMeters = 0) => {
    const v = (window as any).currentRenderingViewer || viewerRef.current;
    if (!v) return true;
    if (v.scene.mode !== Cesium.SceneMode.SCENE3D) return true;
    const point = Cesium.Cartesian3.fromDegrees(lon, lat, altMeters, Cesium.Ellipsoid.WGS84, scratchPoint);
    const normal = Cesium.Ellipsoid.WGS84.geodeticSurfaceNormal(point, scratchNormal);
    Cesium.Cartesian3.subtract(v.camera.positionWC, point, scratchDiff);
    const toCamera = Cesium.Cartesian3.normalize(scratchDiff, scratchToCamera);
    return Cesium.Cartesian3.dot(normal, toCamera) > 0.015;
  }, [viewerRef]);

  return {
    addAOI,
    isSurfacePointCameraFacing,
  };
}
